import React, { useEffect } from "react";
import { Card, Tabs } from "@mantine/core";
import axios from "axios";
import { shallow } from "zustand/shallow";

import CheckIns from "./CheckIns";
import GeneralSettings from "./GeneralSettings";

import useAppStore from "./location-settings-store";

const tabDefs = {
  general: "general",
  checkin: "checkin",
};

export default function LocationSettings({ locationId, fetchLocation }) {
  const { settings, setSettings } = useAppStore(
    (state) => ({
      settings: state.settings,
      setSettings: state.setSettings,
    }),
    shallow
  );

  useEffect(() => {
    fetchSettings();
  }, []);

  function fetchSettings() {
    axios
      .get(`/locations/${locationId}/settings/`)
      .then(({ data }) => {
        setSettings({ ...settings, ...data.response[0] });
      })
      .catch((err) => {
        setSettings({});
      });
  }

  function updateSettings(newSettings) {
    const req = { location_id: locationId, settings: newSettings };

    axios
      .put(`/locations/${locationId}/settings/`, req)
      .then(() => {
        fetchSettings();
      })
      .then(() => fetchLocation())
      .catch((err) => {});
  }

  function onUpdate(newSettings) {
    setSettings({ ...settings, ...newSettings });
    updateSettings({ ...settings, ...newSettings });
  }

  return (
    <Card>
      <Tabs
        onChange={(e) => onUpdate({ activeTab: e })}
        value={settings.activeTab}
      >
        <Tabs.List mb="xl">
          <Tabs.Tab value={tabDefs.general}>General</Tabs.Tab>
          <Tabs.Tab value={tabDefs.checkin}>Check-In</Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value={tabDefs.general}>
          <GeneralSettings onUpdate={(e) => onUpdate({ ...e })} />
        </Tabs.Panel>
        <Tabs.Panel value={tabDefs.checkin}>
          <CheckIns onUpdate={(e) => onUpdate({ ...e })} />
        </Tabs.Panel>
      </Tabs>
    </Card>
  );
}
